import { render, staticRenderFns } from "./CommonSchoolSearch.vue?vue&type=template&id=ef40c55a&scoped=true"
import script from "./CommonSchoolSearch.vue?vue&type=script&lang=js"
export * from "./CommonSchoolSearch.vue?vue&type=script&lang=js"
import style0 from "./CommonSchoolSearch.vue?vue&type=style&index=0&id=ef40c55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef40c55a",
  null
  
)

export default component.exports